import { ListResult } from '@lemoncloud/codes-backend-api/dist/cores/types';
import { ProjectBody, ProjectView } from '@lemoncloud/codes-goods-api';
import { Params } from '@lemoncloud/lemon-web-core';

import { webCore } from '@codes/web-core';

import { UpdateProjectDTO } from '../types';

const BACKEND_ENDPOINT = import.meta.env.VITE_BACKEND_ENDPOINT.toLowerCase();

export const fetchProjectsByWorkspaceId = async (
    workspaceId: string,
    params: Params
): Promise<ListResult<ProjectView>> => {
    if (!workspaceId) {
        throw new Error('fetchProjectsByWorkspaceId: @workspaceId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/projects/${workspaceId}/list`,
        })
        .setParams({ page: 0, limit: 50, view: 'admin', ...params })
        .setBody({ workspaceId })
        .execute<ListResult<ProjectView>>();

    return { ...data };
};

export const fetchProjectById = async (projectId?: string): Promise<ProjectView> => {
    if (!projectId) {
        throw new Error('fetchProjectById: @projectId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/projects/${projectId}/detail`,
        })
        .execute<ProjectView>();

    return { ...data };
};

export const createProject = async (projectBody: ProjectBody): Promise<ProjectView> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/projects/0`,
        })
        .setBody({ ...projectBody })
        .execute<ProjectView>();

    return data;
};

export const updateProject = async (updateProjectDTO: UpdateProjectDTO): Promise<ProjectView> => {
    const { projectId, ...data } = updateProjectDTO;
    if (!projectId) {
        throw new Error('updateProject: @projectId is required');
    }

    const response = await webCore
        .buildSignedRequest({
            method: 'PUT',
            baseURL: `${BACKEND_ENDPOINT}/projects/${projectId}`,
        })
        .setBody({ ...data })
        .execute<ProjectView>();

    return response.data;
};

export const deleteProject = async (projectId: string): Promise<ProjectView> => {
    if (!projectId) {
        throw new Error('deleteProject: @projectId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'DELETE',
            baseURL: `${BACKEND_ENDPOINT}/projects/${projectId}`,
        })
        .setBody({})
        .execute<ProjectView>();

    return data;
};
